const runHooks = [];

// To return true, all functions must return true.
function add(fnc) {
  runHooks.push(fnc);
}

// When a form is saved the scroll position may change as elements are removed
// and then added to the DOM.
// This makes surethe loading pop-up stays centered.
function resetLoadingPopup(initialScrollY) {
  const scrollYDiff = initialScrollY - window.pageYOffset;
  // We only need to do this if the scroll offset has changed.
  if(typeof scrollYDiff === 'number' && !isNaN(scrollYDiff) && scrollYDiff !== 0) {
    const loadingMessage = $('#loading_popup_message_txt').text();
    window.hideLoadPopup();
    window.displayLoadPopup(loadingMessage);
  }
}

function run(callBack) {
   const initialScrollY = window.pageYOffset;
   const resolvedHooks = runHooks.map(hook => hook());
   Promise.all(resolvedHooks).then(() => {
    resetLoadingPopup(initialScrollY);
    callBack();
   });
}

const service = {
  run,
  add
};

window.saveHookService = service;

module.exports = service;
